export default {
    namespaced: true,
    state: {
        products: [],
        articles: []
    },
    getters: {
        products(state) {
            return state.products;
        },
        cnt(state) {
            return state.products.length;
        },
        inCart(state) {
            return state.articles;
        },
        summ(state) {
            let s = 0
            state.products.forEach(el => {
                s += parseInt(el.count) * parseInt(el.price)
            })
            return s
        },

    },
    mutations: {
        add(state, item) {
            if (state.articles.indexOf(item.id) === -1) {
                state.products.push(item);
                state.articles.push(item.id)
            }
        },
        clear(state) {
            state.products = []
            state.articles = []
            localStorage.clear()

        },
        plus(state, id) {

            state.products.forEach(el => {
                if (!el.maxCount) { el.maxCount = 5 }
                if (el.id === id) {
                    if (el.count >= el.maxCount) { el.count = el.maxCount } else { el.count++ }
                }
            })
        },
        minus(state, id) {

            state.products.forEach(el => {
                if (el.id === id) {
                    if (el.count <= 1) { el.count = 1 } else { el.count-- }
                }
            })
        },
        remove(state, id) {
            let idx = state.articles.indexOf(id)
            state.products.splice(idx, 1)
            state.articles.splice(idx, 1)
        }
    },
    actions: {
        add(store, id_product) {
            store.commit('add', id_product);
        },
        remove(store, id_product) {
            store.commit('remove', id_product);
        }
    }
};